import {clamp} from "p3";
import common from "../../common";

export default class Quest {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        this._id = id;
        this._owner = owner;

        this._value = 0;
        this._target = 0;

        this.name = "";
        this.description = "";
        this.icon = "icon_npc_quest_new";
        this.playOutro = false;
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        this._target = metadata.target ? Math.max(0, metadata.target) : 1;
        this.playOutro = metadata.playOutro || false;
    }

    /**
     * @param {GameScene} game
     */
    onQuestInit(game) {
        
    }

    /**
     * @param {GameScene} game
     * @param {number} progress
     */
    onQuestProgress(game, progress) {
    }

    /**
     * @param {GameScene} game
     */
    onQuestComplete(game) {
        if (!common.saveData.settings.musicMute) {
            P3.audio.playSound("music_major_quest_1_complete");
        }
    }

    /**
     * @returns {string}
     */
    get id() {
        return this._id;
    }

    /**
     * @return {string}
     */
    get owner() {
        return this._owner;
    }

    /**
     * @return {number}
     */
    get progress() {
        return clamp(Math.round((this._value / this._target) * 100) / 100, 0, 1);
    }

    /**
     * @return {number}
     */
    get value() {
        return this._value;
    }

    /**
     * @param {number} value
     */
    set value(value) {
       // //console.log('QUEST VALUE CHANGE', this._value, value);
        this._value = clamp(value, 0, this._target);
    }

    /**
     * @return {number}
     */
    get target() {
        return this._target;
    }

    /**
     * @return {boolean}
     */
    get isRequirementsMet() {
        return this.progress >= 1;
    }
}
